var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"display":"flex","justify-content":"center"}},[_c('div',{staticClass:"c2-login-container",style:(_vm.containerStyle)},[_c(_vm.loginComponent,{tag:"components"})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }